import './Support.scss'
import React, {useState} from "react";

import feedbackIcon from '../../Assets/images/beta-feedback.svg'

const Support = () => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  const sendFeedback = () => {
    console.log(title, description);
  }

  return (
    <div className="container vh-100 d-flex">
      <div className="feedback-form d-flex flex-column align-items-center my-auto">
        <img src={feedbackIcon} alt=""/>
        <span className="feedback-form text-center">Wanna leave feedback? <br/> It will be very useful for us!</span>
        <input type="text"
               value={title}
               placeholder="Title"
               onChange={e => {
                 setTitle(e.target.value);
               }}/>
        <textarea name=""
                  id=""
                  rows={10}
                  value={description}
                  placeholder="Describe your issue here..."
                  onChange={e => {
                    setDescription(e.target.value);
                  }}></textarea>
        <button type="button" onClick={sendFeedback}>Send</button>
      </div>
    </div>
  )
}

export default Support